/*
  HUSTLESTREET — Reveal helper (PHASE 7)
  File: assets/hs-reveal.js

  Usage in a section:
    <hs-reveal> ... <div data-hs-reveal style="--hs-d: 1;"> ... </div> ... </hs-reveal>
    <script src="{{ 'hs-reveal.js' | asset_url }}" defer="defer"></script>

  Behaviour:
    - Without JS, or with prefers-reduced-motion, content is always visible.
    - With JS, adds .is-reveal-ready (hidden state), then .is-revealed when in view.
    - Safe to load multiple times (guarded).
*/
(function () {
  if (!('customElements' in window) || customElements.get('hs-reveal')) return;

  class HsReveal extends HTMLElement {
    connectedCallback() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        this.classList.add('is-revealed');
        return;
      }

      this.classList.add('is-reveal-ready');

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-revealed');
              this.observer.disconnect();
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('hs-reveal', HsReveal);
})();